module.exports = "\r\n\r\n\r\n@media print {\r\n    #canvaswrapper {\r\n        margin: 0 auto;\r\n        max-width:700px !important;\r\n    }\r\n    #canvasImg {       \r\n        height: 394px !important;\r\n    }\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/modal/client-detail/top/slideshow/slideshowDSD/modal-client-detail-slideshow-dsd.component.css
// module id = ./src/app/app_manager/modal/client-detail/top/slideshow/slideshowDSD/modal-client-detail-slideshow-dsd.component.css
// module chunks = main